export const DATASET_GROUPS = [
  {
    label: 'Core Sanctions',
    datasets: [
      { id: 'us_ofac_sdn', label: 'US OFAC SDN', region: 'US' },
      { id: 'eu_fsf', label: 'EU Consolidated List', region: 'EU' },
      { id: 'un_sc_sanctions', label: 'UN Security Council', region: 'International' },
      { id: 'gb_hmt_sanctions', label: 'UK HMT Sanctions', region: 'UK' },
    ]
  },
  {
    label: 'Extended Sanctions',
    datasets: [
      { id: 'gb_fcdo_sanctions', label: 'UK FCDO', region: 'UK' },
      { id: 'au_dfat_sanctions', label: 'Australia DFAT', region: 'Australia' },
      { id: 'ca_dfatd_sema_sanctions', label: 'Canada SEMA', region: 'Canada' },
      { id: 'jp_mof_sanctions', label: 'Japan MOF', region: 'Japan' },
      { id: 'ch_seco_sanctions', label: 'Switzerland SECO', region: 'Switzerland' },
      { id: 'hk_sfc_sanctions', label: 'Hong Kong SFC', region: 'Hong Kong' },
      { id: 'sg_mas_sanctions', label: 'Singapore MAS', region: 'Singapore' },
    ]
  },
  {
    label: 'PEP & Crime',
    datasets: [
      { id: 'pep', label: 'Politically Exposed Persons', region: 'Global' },
      { id: 'interpol_red_notices', label: 'Interpol Red Notices', region: 'International' },
      { id: 'us_fbi_most_wanted', label: 'FBI Most Wanted', region: 'US' },
    ]
  },
  {
    label: 'Debarment',
    datasets: [
      { id: 'us_bis_denied', label: 'US BIS Denied Persons', region: 'US' },
      { id: 'worldbank_debarred', label: 'World Bank Debarred', region: 'International' },
    ]
  },
];

export const DEFAULT_DATASETS = ['us_ofac_sdn', 'eu_fsf', 'un_sc_sanctions', 'gb_hmt_sanctions', 'pep'];

export const ALL_DATASET_IDS = DATASET_GROUPS.reduce((acc, group) => [...acc, ...group.datasets.map(d => d.id)], []);
